export default __webpack_public_path__ + "static/media/badges_icon.a1cdf462.png";